module.exports = __webpack_public_path__ + "5b5c298318973bc02c280eacd84d6ab2.svg";


//////////////////
// WEBPACK FOOTER
// ./images/trash.svg
// module id = 64
// module chunks = 0